import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { disable2FA } from '../services/api';

export default function AccountSecurityPage() {
  const { user, refreshUser } = useAuth();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showDisableForm, setShowDisableForm] = useState(false);

  const handleDisable = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await disable2FA(password);
      await refreshUser();
      setShowDisableForm(false);
      setPassword('');
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to disable two-factor authentication');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 500 }}>
      <h2>Account security</h2>
      <div className="card" style={{ marginTop: '1rem' }}>
        <p><strong>Email:</strong> {user?.email}</p>
        <p style={{ marginBottom: '1rem' }}>
          <strong>Two-factor authentication:</strong> {user?.twoFactorEnabled ? 'Enabled' : 'Disabled'}
        </p>

        {!user?.twoFactorEnabled ? (
          <button className="btn-primary" onClick={() => navigate('/account/security/setup')}>
            Enable two-factor authentication
          </button>
        ) : !showDisableForm ? (
          <button className="btn-secondary" onClick={() => setShowDisableForm(true)}>
            Disable two-factor authentication
          </button>
        ) : (
          <form onSubmit={handleDisable}>
            <label htmlFor="disable-2fa-password" style={{ display: 'block', marginBottom: 4, fontWeight: 500 }}>Confirm your password</label>
            <input
              id="disable-2fa-password"
              name="password"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoFocus
            />
            {error && <p className="error">{error}</p>}
            <div style={{ display: 'flex', gap: 8, marginTop: '0.75rem', flexWrap: 'wrap' }}>
              <button type="submit" className="btn-primary" disabled={loading}>
                {loading ? 'Disabling…' : 'Confirm disable'}
              </button>
              <button type="button" className="btn-secondary" onClick={() => setShowDisableForm(false)}>
                Cancel
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
